module.exports = __webpack_public_path__ + "static/HIGHLIGHT_wake-d208ae3664e958594deb78b29c04f080.jpeg";